export default __webpack_public_path__ + "static/media/Path3358.832d4deb.svg";